export default __webpack_public_path__ + "static/media/n1.4.4eb66d5e.jpg";